import { render, staticRenderFns } from "./dietary_preferences_reminder.vue?vue&type=template&id=7d06f1ae&scoped=true&"
import script from "./dietary_preferences_reminder.vue?vue&type=script&lang=js&"
export * from "./dietary_preferences_reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06f1ae",
  null
  
)

export default component.exports